import React from 'react';

const About: React.FC = () => {
  const skills = [
    'AI Implementation', 'Clinical Workflow Design', 'Product Strategy', 'Healthcare Operations',
    'Impact Measurement', 'Human-Centered Design', 'Go-to-Market', 'Stakeholder Management',
  ];

  const tools = [
    'Claude Code', 'Cursor', 'Claude Design', 'Figma', 'Python', 'SQL', 'Tableau', 'Excel',
  ];

  return (
    <section id="about" className="py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid md:grid-cols-5 gap-12">
          {/* Short bio */}
          <div className="md:col-span-3">
            <h2 className="text-3xl md:text-4xl font-bold text-ink-800 tracking-tight mb-6">
              Who I am
            </h2>
            <div className="space-y-4 text-lg text-ink-600 leading-relaxed">
              <p>
                I'm a healthcare product &amp; operations leader delivering care to
                underserved communities.
              </p>
              <p>
                Growing up caring for four elderly grandparents taught me how broken care
                navigation can be. I pair that lived experience with human-centered
                design to build products that improve patient outcomes, reduce caregiver
                burden, and expand access.
              </p>
              <p>
                I've built provider workflow tools to ensure clinician compliance and timely
                billing, developed a framework to evaluate the impact of tech solutions on
                Medi-Cal enrollment and redetermination in NorCal, and consulted for clients
                across the healthcare industry (hospital systems, state health departments,
                MedTech, biopharma, COVID response).
              </p>
              <p>
                I am pursuing an MBA at the Stanford Graduate School of Business. I have a
                B.S. in Systems Engineering, B.A. in Economics, and minor in Computer Science
                from the University of Virginia.
              </p>
            </div>
          </div>

          {/* Skills */}
          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-blush-500 mb-4">
              Skills &amp; Expertise
            </h3>
            <div className="flex flex-wrap gap-2 mb-6">
              {skills.map((skill) => (
                <span
                  key={skill}
                  className="px-3 py-1.5 bg-blush-50 text-ink-600 rounded-full text-sm font-medium border border-blush-100"
                >
                  {skill}
                </span>
              ))}
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider text-sky-500 mb-4">
              Tools
            </h3>
            <div className="flex flex-wrap gap-2">
              {tools.map((tool) => (
                <span
                  key={tool}
                  className="px-3 py-1.5 bg-sky-50 text-ink-600 rounded-full text-sm font-medium border border-sky-100"
                >
                  {tool}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
